import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";

// GeneralViews
import NotFound from "@/pages/NotFoundPage.vue";

// Admin pages
import Dashboard from "@/pages/Dashboard.vue";
import UserProfile from "@/pages/UserProfile.vue";
import Notifications from "@/pages/Notifications.vue";
import Icons from "@/pages/Icons.vue";
import Maps from "@/pages/Maps.vue";
import Typography from "@/pages/Typography.vue";
import TableList from "@/pages/TableList.vue";
import Enlaces from "@/pages/Enlaces/Enlaces.vue";
import Numeros from "@/pages/Numeros/Numeros.vue";
import Login from "@/pages/Login/LoginPage.vue";
import System from "@/pages/UserSystem/UserSystemPage.vue";

import Chat from "@/pages/Chat/Chat.vue";


const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/login",
    children: [

    // path: "/",
    // component: Login,
    // redirect: "/Login",
    // children: [
      {
        path: "dashboard",
        name: "dashboard",
        component: Dashboard,
      },
      {
        path: "login",
        name: "login",
        component: Login,
      },
      {
        path: "enlaces",
        name: "enlaces",
        component: Enlaces,
      },
      {
        path: "numeros",
        name: "numeros",
        component: Numeros,
      },
      {
        path: "chat",
        name: "chat",
        component: Chat,
      },
      {
        path: "stats",
        name: "stats",
        component: UserProfile,
      },
      {
        path: "notifications",
        name: "notifications",
        component: Notifications,
      },
      {
        path: "icons",
        name: "icons",
        component: Icons,
      },
      {
        path: "maps",
        name: "maps",
        component: Maps,
      },
      {
        path: "typography",
        name: "typography",
        component: Typography,
      },
      {
        path: "table-list",
        name: "table-list",
        component: TableList,
      },
      {
        path: "system",
        name: "system",
        component: System,
      },
    ],
  },
  // { path: "enlaces",
  // component: Enlaces,
  // redirect: "/enlaces"},
  { path: "*", component: NotFound },

  
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
